import CommunicationBoard from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CommunicationBoard/CommunicationBoard'
import CreditBooster from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/CreditBooster/CreditBooster'
import Distributor from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/Distributor'
import FidelityMaximizerSidebar from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/FidelityMaximizer/FidelityMaximizerSidebar'
import HistoricSales from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/HistoricSales/HistoricSales'
import IbanVerifier from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/IbanVerifier/IbanVerifier'
import Resources from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Resources/Resources'
import Tools from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Tools/Tools'
import ScheduleCallback from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/ScheduleCallback'
import useLegacyRightPanel from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/useLegacyRightPanel'

interface LegacyRightPanelProps {
  country: string
}

const LegacyRightPanel = ({ country }: LegacyRightPanelProps) => {
  const {
    hidden,
    ibanVerifierHidden,
    rightColumnContainerStyle,
    rightColumnElementStyle,
    rightColumnElementStatelessStyle,
  } = useLegacyRightPanel(country)

  if (hidden) return null

  return (
    <div style={rightColumnContainerStyle}>
      <div style={{ width: '100%' }}>
        <ScheduleCallback />
      </div>
      <div style={rightColumnElementStatelessStyle}>
        <Resources country={country} />
      </div>
      <div style={rightColumnElementStatelessStyle}>
        <CreditBooster country={country} />
      </div>
      <div style={rightColumnElementStatelessStyle}>
        <FidelityMaximizerSidebar />
      </div>
      <div style={rightColumnElementStatelessStyle}>
        <CommunicationBoard />
      </div>
      <div style={rightColumnElementStatelessStyle}>
        <IbanVerifier hidden={ibanVerifierHidden} />
      </div>
      <div style={rightColumnElementStatelessStyle}>
        <Distributor />
      </div>
      <div style={rightColumnElementStyle}>
        <HistoricSales />
      </div>
      <div style={rightColumnElementStatelessStyle}>
        <Tools />
      </div>
    </div>
  )
}

export default LegacyRightPanel
